import { combineReducers } from "redux";

import moduleToggler from "./moduleToggler";
import routeTo from "./route";
import chartPage from "./chartPage";
import demo from "./demo";

export default combineReducers({
	moduleToggler,
	routeTo,
	chartPage,
	demo,
});

// rootReducer;




/** WEBPACK FOOTER **
 ** ./src/scripts/reducers/index.js
 **/